import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AttachmentComponent} from './attachment.component';
import {DndModule} from 'ngx-drag-drop';
import {TranslocoModule} from '@ngneat/transloco';
import {ButtonModule} from '../button/button.module';
import {FormsModule} from '@angular/forms';
import {FileSizeModule} from '@shared/pipes/file-size/file-size.module';
import {IconLibraryService, IconsModule, plBuilderAttachment, plBuilderAttachmentVertical, plBuilderDownload} from '@paperlessio/sdk/icons';
import {FilePickerModule} from '@shared/controls/file-picker/file-picker.module';
import {LoadingSpinnerModule} from '@paperlessio/sdk/components/loading-spinner';

@NgModule({
  declarations: [
    AttachmentComponent
  ],
  imports: [
    CommonModule,
    IconsModule,
    DndModule,
    TranslocoModule,
    ButtonModule,
    FilePickerModule,
    FormsModule,
    FileSizeModule,
    LoadingSpinnerModule,
  ],
  exports: [
    AttachmentComponent
  ]
})
export class AttachmentModule {
  constructor(library: IconLibraryService) {
    library.addIcons(plBuilderDownload, plBuilderAttachment, plBuilderAttachmentVertical);
  }
}
